import React from "react";

export function Equalizer({ active = true, className = "", barClass = "bg-gold" }) {
  return (
    <div className={`flex items-end gap-[2px] h-4 ${className}`} aria-hidden="true">
      {[0, 1, 2, 3].map((i) => (
        <span
          key={i}
          className={`w-[3px] rounded-full ${barClass}`}
          style={{
            height: active ? "100%" : "30%",
            animation: active ? `eq 0.8s ease-in-out infinite` : "none",
            animationDelay: `${i * 0.15}s`,
          }}
        />
      ))}
    </div>
  );
}
